export const EMPLOYED_RUS = 'Трудоустроены';
export const EMPLOYED_ENG = 'Employed';

export const PROBATION_STATES = [20882, 20834];
export const EMPLOYEED_STATES = [20883, 20835];
export const EXCLUDED_STATES = [20884, 20837];
export const CANDIDATE_STATES = [20896, 20880, 20832, 20829];
